module.exports = __webpack_public_path__ + "img/pa.51112aca.svg";